import { useUser } from '~/providers';
import {
  expandUserRoles,
  isAccountAdmin,
  isBackstageUser,
  isRaffleAdmin,
  routePermissions,
} from '~/utils';

import type { RouteType } from '~/utils';

export const useUserRoles = () => {
  const {
    user: { roles },
  } = useUser();

  const expandedRoles = expandUserRoles(roles);

  function canAccess(route: RouteType): boolean {
    const allowedRoles = routePermissions[route];
    return allowedRoles.some((role) => expandedRoles.includes(role));
  }

  return {
    expandedRoles,
    isRaffleAdmin: isRaffleAdmin(roles),
    isBackstageUser: isBackstageUser(roles),
    isAccountAdmin: isAccountAdmin(roles),
    canAccess,
  };
};
